import React, { useState } from "react";
import PayoutTable from "../table/PayoutTable";
import SearchIcon from "../Icons/SearchIcon";
import CustomButton from "../Buttons/Button";
import { useSelector } from "react-redux";
import PayoutModal from "../modal/PayoutModal";
import { useParams } from "react-router-dom";

function PayoutHistory({ cycle, type, currency }) {
  const { id } = useParams();

  return (
    <div>
      <div className="flex justify-between mb-8"></div>

      <PayoutTable cycle={cycle} type={type} />
    </div>
  );
}

export default PayoutHistory;
